import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

import {
  CadastrarPrecoBodyModel,
  IEditPreco,
  IPatchPreco
} from './preco.model';

@Injectable({
  providedIn: 'root'
})
export class PrecoService {
  constructor(private http: HttpClient) {}

  CreatePreco(body: CadastrarPrecoBodyModel, guid: string): Observable<any> {
    const headers = new HttpHeaders({
      IdempotencyKey: guid
    });

    return this.http.post<any>(
      `${environment.baseURL}Preco/CreatePreco`,
      body,
      { headers: headers }
    );
  }

  public EditarPreco(pkPreco: number, body: IEditPreco): Observable<any> {
    const url = `${environment.baseURL}Preco/UpdatePreco?IdPreco=${pkPreco}`;

    return this.http.put<any>(url, body);
  }

  public PatchPreco(id: number, body: IPatchPreco): Observable<any> {
    const url = `${environment.baseURL}Preco/PatchPrecoStatus?id=${id}`;

    return this.http.patch<any>(url, body);
  }

  public GetPreco({
    servico,
    tipoCarreta,
    tipoCarga,
    pageNumber,
    pageSize,
    status = 1
  }: {
    servico?: number;
    tipoCarreta?: number;
    tipoCarga?: number;
    pageNumber?: number;
    pageSize?: number;
    status: number;
  }): Observable<any> {
    const invalid = ['', undefined, 0, NaN];

    const url = `${environment.baseURL}Preco/GetPrecos`;
    const params: any = {};

    if (!invalid.includes(servico)) {
      params.PK_SRVC = servico;
    }
    if (!invalid.includes(tipoCarga)) {
      params.PK_CRGA = tipoCarga;
    }
    if (!invalid.includes(tipoCarreta)) {
      params.PK_TIPO_CRRT = tipoCarreta;
    }
    if (!invalid.includes(pageNumber)) {
      params.PAGE_NUMBER = pageNumber;
    }
    if (!invalid.includes(pageSize)) {
      params.PAGE_SIZE = pageSize;
    }

    params.NU_STTS_ALL = status;

    return this.http.get<any>(url, { params });
  }

  public GetPrecoById(id?: number): Observable<any> {
    let url = `${environment.baseURL}Preco/GetPrecoById`;
    if (id !== undefined) {
      url += `?PK_PRCO=${id}`;
    }
    return this.http.get<any>(url);
  }

  public GetPrecoAgendamentoByServico(idServico?: number): Observable<any> {
    let url = `${environment.baseURL}Preco/GetPrecoAgendamentoByServico`;
    if (idServico !== undefined) {
      url += `?idServico=${idServico}`;
    }
    return this.http.get<any>(url);
  }
}
